export function IconAdd() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill="currentColor" d="M7 2a1 1 0 0 0-2 0v3H2a1 1 0 0 0 0 2h3v3a1 1 0 1 0 2 0V7h3a1 1 0 1 0 0-2H7V2z"/>
        </svg>
    );
}
